// extracted by mini-css-extract-plugin
export default {"sectionHeader":"section-header_sectionHeader__UFJA0"};